import type { User } from "@investhinks/api-client";

export const LOGIN = "LOGIN";
export const ACTIVATE_EXTENDED_MODE = "ACTIVATE_EXTENDED_MODE";
export const LOGOUT = "LOGOUT";
export const IMPERSONATE_USER = "IMPERSONATE_USER";
export const RETURN_TO_ADMIN = "RETURN_TO_ADMIN";

export const login = (token: string, user: User) => ({
  type: LOGIN,
  payload: { token, user },
});

export const activateExtendedMode = () => ({
  type: ACTIVATE_EXTENDED_MODE,
});

export const logout = () => ({
  type: LOGOUT,
  payload: null,
});

export const impersonateUser = (impersonationToken: string, impersonatedUser: User) => ({
  type: IMPERSONATE_USER,
  payload: { impersonationToken, impersonatedUser },
});

export const returnToAdmin = () => ({
  type: RETURN_TO_ADMIN,
});

export const REFRESH_IMPERSONATION = "REFRESH_IMPERSONATION";

export const refreshImpersonation = (updatedUser: User) => ({
  type: REFRESH_IMPERSONATION,
  payload: { updatedUser },
});
